import './OrderExport.scss';
import Component from './OrderExport.js';
export default Component;
